"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_window_1 = require("react-window");
var fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
var components_1 = require("./components");
var rows_1 = require("./rows");
var features_1 = require("./features");
var View_1 = require("../View");
var Text_1 = require("../Text");
var helpers_1 = require("../helpers");
var StackView_1 = require("../StackView");
var filterWithoutFakeColumns_1 = require("./utils/filterWithoutFakeColumns");
var DotsIcon_1 = require("./icons/DotsIcon");
exports.gridSubheaderTestId = 'grid-subheader-container';
var onScrollHandler = function (_a) {
    var scrollProps = _a.scrollProps, layoutWidth = _a.layoutWidth, gridHeight = _a.height, onScroll = _a.onScroll, headerRef = _a.headerRef, totalRowRef = _a.totalRowRef;
    if (headerRef.current) {
        // eslint-disable-next-line no-param-reassign
        headerRef.current.style.transform = "translate3d(-" + scrollProps.scrollLeft + "px, 0, 0)";
    }
    if (totalRowRef.current) {
        // eslint-disable-next-line no-param-reassign
        totalRowRef.current.style.transform = "translate3d(-" + scrollProps.scrollLeft + "px, 0, 0)";
    }
    onScroll === null || onScroll === void 0 ? void 0 : onScroll(scrollProps, { gridHeight: gridHeight, gridWidth: layoutWidth });
};
var defaultEmptyColumnsContentRender = function (customText) {
    var dotsIconMask = '{{dots}}';
    var text = customText ||
        "Select a column from the Column selection (" + dotsIconMask + ") to display records";
    var hasDotsIconMask = text.indexOf(dotsIconMask) >= 0;
    var textParts = text.split(dotsIconMask);
    return (react_1.default.createElement(StackView_1.StackView, { align: StackView_1.STACK_ALIGN.center, size: { height: helpers_1.SIZE_XL } },
        textParts[0] && react_1.default.createElement(Text_1.Text, null, textParts[0]),
        hasDotsIconMask && (react_1.default.createElement(View_1.View, { align: View_1.VIEW_ALIGN.center, size: { width: helpers_1.SIZE_L, height: helpers_1.SIZE_L } },
            react_1.default.createElement(DotsIcon_1.DotsIcon, null))),
        textParts[1] && react_1.default.createElement(Text_1.Text, null, textParts[1])));
};
function GridCore(_a) {
    var subheader = _a.subheader, selectionSubheaderRenderer = _a.selectionSubheaderRenderer, gridRefInit = _a.gridRef, rowContainerRenderer = _a.rowContainerRenderer, emptyColumnsText = _a.emptyColumnsText, _b = _a.emptyColumnsContentRender, emptyColumnsContentRender = _b === void 0 ? defaultEmptyColumnsContentRender : _b, isRowDisabled = _a.isRowDisabled, isRowInactive = _a.isRowInactive, forcePagination = _a.forcePagination, disabled = _a.disabled, texts = _a.texts, props = __rest(_a, ["subheader", "selectionSubheaderRenderer", "gridRef", "rowContainerRenderer", "emptyColumnsText", "emptyColumnsContentRender", "isRowDisabled", "isRowInactive", "forcePagination", "disabled", "texts"]);
    var _c = features_1.useGridContext(), _d = _c.state, data = _d.data, availableRowsHeight = _d.availableRowsHeight, layoutWidth = _d.layoutWidth, height = _d.height, rowHeight = _d.rowHeight, initialScrollTop = _d.initialScrollTop, isEmpty = _d.isEmpty, selection = _d.selection, pagination = _d.pagination, onSelectionChange = _c.onSelectionChange, onScroll = _c.onScroll;
    var _e = features_1.useGridToggleableContext(), rowWidth = _e.rowWidth, visibleColumns = _e.visibleColumns;
    var headerRef = react_1.useRef();
    var totalRowRef = react_1.useRef(null);
    var gridRef = gridRefInit || react_1.useRef();
    var gridBoxRef = react_1.useRef(null);
    var emptyRenderer = props.emptyRenderer || (function () { return react_1.default.createElement(components_1.GridEmpty, { text: texts === null || texts === void 0 ? void 0 : texts.empty }); });
    var Row = react_1.useRef(react_1.default.memo(rows_1.createRow({
        isDisabled: isRowDisabled,
        isInactive: isRowInactive,
        containerRenderer: rowContainerRenderer
    }), fast_deep_equal_1.default));
    var prevSelection = react_1.useRef(null);
    var prevActivePage = react_1.useRef((pagination === null || pagination === void 0 ? void 0 : pagination.activePage) || 1);
    var scrollTop = react_1.useRef(initialScrollTop || 0);
    var hasColumns = visibleColumns.filter(filterWithoutFakeColumns_1.filterWithoutFakeColumns).length > 0;
    react_1.useEffect(function () {
        var _a, _b;
        if (pagination) {
            var activePage = pagination.activePage;
            var pageChanged = !fast_deep_equal_1.default(activePage, prevActivePage.current);
            if (pageChanged) {
                prevActivePage.current = activePage;
                if ((_a = gridRef === null || gridRef === void 0 ? void 0 : gridRef.current) === null || _a === void 0 ? void 0 : _a.scrollToItem) {
                    gridRef.current.scrollToItem({ rowIndex: 0 });
                }
                return;
            }
        }
        if (selection) {
            if (selection.selected.length !== 1 || selection.multiple) {
                prevSelection.current = null;
                return;
            }
            var field_1 = selection.field;
            var selected_1 = selection.selected[0];
            var selectedRowIndex = data.findIndex(function (el) { return selected_1[field_1] === el[field_1]; });
            var currentSelection = { selectedRowIndex: selectedRowIndex, selected: selected_1 };
            var selectedRowPosition = rowHeight * selectedRowIndex;
            var isRowVisible = selectedRowPosition > scrollTop.current &&
                selectedRowPosition + rowHeight < scrollTop.current + availableRowsHeight;
            var selectionChanged = !fast_deep_equal_1.default(currentSelection, prevSelection.current);
            if (selectionChanged) {
                prevSelection.current = currentSelection;
                var needToScroll = !isRowVisible;
                if (needToScroll) {
                    (_b = gridRef.current) === null || _b === void 0 ? void 0 : _b.scrollToItem({ rowIndex: selectedRowIndex });
                }
            }
        }
    });
    react_1.useEffect(function () {
        var disableUserSelect = function (e) {
            if (gridBoxRef.current) {
                if (e.shiftKey) {
                    gridBoxRef.current.style.userSelect = 'none';
                }
                else {
                    gridBoxRef.current.style.userSelect = '';
                }
            }
        };
        document.addEventListener('keydown', disableUserSelect);
        document.addEventListener('keyup', disableUserSelect);
        return function () {
            document.removeEventListener('keydown', disableUserSelect);
            document.removeEventListener('keyup', disableUserSelect);
        };
    }, []);
    var selectionValue = helpers_1.useStateValue(selection, [selection]);
    var gridDataValue = helpers_1.useStateValue(data, [data]);
    react_1.useEffect(function () {
        // Arrow selection functional
        var cb = function (e) {
            var _a;
            // TODO: Uncomment when fix
            return;
            var isArrowKey = e.keyCode === helpers_1.KeyCode.DownArrow || e.keyCode === helpers_1.KeyCode.UpArrow;
            var selected = ((_a = selectionValue.getValue()) === null || _a === void 0 ? void 0 : _a.selected) || [];
            var hasSelection = selected.length;
            var gridData = gridDataValue.getValue();
            if (isArrowKey && hasSelection) {
                var edgeRow = e.keyCode === helpers_1.KeyCode.DownArrow ? selected[selected.length - 1] : selected[0];
                var edgeIndex = gridData.indexOf(edgeRow);
                var differenceIndex = e.keyCode === helpers_1.KeyCode.DownArrow ? 1 : -1;
                if (edgeIndex > -1) {
                    var nextIndex = edgeIndex + differenceIndex;
                    if (nextIndex < 0 || nextIndex > gridData.length - 1) {
                        return;
                    }
                    var nextRow = gridData[nextIndex];
                    if (!nextRow) {
                        return;
                    }
                    e.preventDefault();
                    e.stopPropagation();
                    var selectionPayload = {
                        selected: [nextRow],
                        current: {
                            rowIndex: nextIndex,
                            rowData: nextRow
                        }
                    };
                    onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange(selectionPayload);
                }
            }
        };
        document.addEventListener('keydown', cb);
        return function () {
            document.removeEventListener('keydown', cb);
        };
    }, []);
    var renderGridContent = function () {
        if (isEmpty) {
            return props.loading ? null : emptyRenderer();
        }
        if (!hasColumns && emptyColumnsText) {
            return defaultEmptyColumnsContentRender(emptyColumnsText);
        }
        if (!hasColumns) {
            return emptyColumnsContentRender();
        }
        return (react_1.default.createElement(react_window_1.FixedSizeGrid, { className: "grid", style: { willChange: 'contents' }, ref: gridRef, height: availableRowsHeight, rowCount: data.length, rowHeight: rowHeight, width: layoutWidth, itemData: data, columnWidth: rowWidth, columnCount: 1, initialScrollTop: initialScrollTop, onScroll: function (scrollProps) {
                scrollTop.current = scrollProps.scrollTop;
                onScrollHandler({
                    scrollProps: scrollProps,
                    layoutWidth: layoutWidth,
                    height: height,
                    onScroll: onScroll,
                    headerRef: headerRef,
                    totalRowRef: totalRowRef
                });
            } }, Row.current));
    };
    return (react_1.default.createElement(components_1.GridBox, { ref: gridBoxRef, disabled: disabled },
        react_1.default.createElement(components_1.GridHeader, { ref: headerRef }),
        subheader && (react_1.default.createElement(View_1.View, { testId: exports.gridSubheaderTestId, borderBottom: View_1.VIEW_BORDER.grid, size: { height: subheader.height + "px", width: '100%' } }, subheader.render())),
        !isEmpty && hasColumns && selectionSubheaderRenderer !== null && (react_1.default.createElement(components_1.GridSelection, { selectionSubheaderRenderer: selectionSubheaderRenderer })),
        hasColumns && react_1.default.createElement(components_1.GridTotal, { ref: totalRowRef }),
        react_1.default.createElement(components_1.GridNotification, null),
        react_1.default.createElement(components_1.GridLoader, null),
        react_1.default.createElement(react_1.default.Fragment, null, renderGridContent()),
        react_1.default.createElement(components_1.GridPagination, { forcePagination: forcePagination })));
}
exports.GridCore = GridCore;
//# sourceMappingURL=GridCore.js.map